@if (shouldShow()) {
  <button
    class="back-button"
    [class.mobile-back]="isMobileScreen()"
    [class.desktop-back]="!isMobileScreen()"
    (click)="goBack()"
    [attr.aria-label]="isMobileScreen() && mobileText() ? mobileText() : 'Go back'">
    <!-- Icon -->
    <svg class="back-icon" [class.mobile-icon]="isMobileScreen()" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <!-- Text (only on mobile if provided) -->
    @if (isMobileScreen() && mobileText()) {
      <span class="back-text">{{ mobileText() }}</span>
    }
  </button>
}
